export const INVOICE_FIELD_LABELS: Record<string, string> = {
  customer_id: 'Customer ID',
  supplier_id: 'Supplier Number',
  supplier_name: 'Supplier Name',
  invoice_currency: 'Currency',
  document_type: 'Document Type',
  invoice_number: 'Invoice Number',
  invoice_date: 'Invoice Date',
  purchase_order_number: 'PO Number',
  total_vat_included_amount: 'Gross Amount',
  total_vat_excluded_amount: 'Net Amount',
  total_vat_amount: 'VAT Amount',
  total_vat_rate_percent: 'VAT Rate (%)',
  organization_id: 'Organization',
  exception_message: 'Exception Message',
};
